<script>
  import { onMount } from 'svelte';

  import Main from '../../shared/Main.svelte';

  import Slideshow from '../../shared/components/Slideshow.svelte';

  export let jsonFile;
  let data = {};


  $: data_items = data.items || [];
  // While waiting for data to load, #each will complain, 
  // that it only iterates over array-like objects.
  // Option 1: wrap {#each} in {#if data_items}
  // Option 2: provide empty array as default

  $: data_config = data.config || {};

  
  onMount( async () => {
    const response = await fetch( jsonFile );
    const json = await response.json();

    // add some more properties
    json.items.forEach( (item, i) => {
      item.active = false
    });

    data = json    
  });

</script>


<Main colorFill="var(--color-blue-light-5)" colorBorder="transparent" fullHeight={false} overflow="hidden">
  <Slideshow items={data_items} config={data_config}/>
</Main>


<style>
  /* DIRTY */
  :global(main){border:none !important;}
</style>

  
